import {Request} from '../request'
import {getLang} from '@/utils/lang'
//创建订单
export function getPocPush() {
    return Request.axiosInstance({
        url: '/poc-push-list',
        method: 'get',
    })
}
